


















































































































import {
  Vue,
  Component,
  Watch,
  Prop,
} from "@/shared/vuepack";
import { Claim } from "@/shared/types";
import Paginator from "@/shared/components/ui/Paginator.vue";
import ClaimRow from "@/employee/components/healthcareExpenseV2/ClaimRow.vue";
import HealthcareExpenseNavigationV2 from "@/employee/components/healthcareExpenseV2/HealthcareExpenseNavigationV2.vue";
import HealthcareExpenseNavigation from "@/employee/components/healthcareExpense/HealthcareExpenseNavigation.vue";
import HealthcareExpensesAdd from "@/employee/components/healthcareExpenseV2/HealthcareExpensesAdd.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { RawLocation } from "vue-router";
import { useClaimStore } from "@/employee/store/claim";
import { useDeductibleTrackerStore } from "@/employee/store/deductibleTracker";
import { useUserStore } from "@/shared/store/user";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import claim from "@/shared/resource/claim";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  computed: {
    claim () {
      return claim;
    }
  },
  components: {
    Paginator,
    ClaimRow,
    HealthcareExpenseNavigationV2,
    HealthcareExpenseNavigation,
    HealthcareExpensesAdd,
    GenericLoadingSpinner
  },
})
export default class ViewClaims extends Vue {
  claimStore = useClaimStore();
  deductibleTrackerStore = useDeductibleTrackerStore();
  userStore = useUserStore();
  portalStore = usePortalCustomizationStore();
  custodianSettingsStore = useCustodianSettingsStore();

  @Prop()
  SettingsRoute: RawLocation;
  showExpenseAddView = false;
  currentClaim: Claim = null;

  mounted () {
    this.userStore.loadPartnerSettings();
    this.loadPage();
    this.deductibleTrackerStore.retrieveHealthPlanIsLinked();

    this.$on("claim-add-expense", claimNumber => {
      this.currentClaim = this.claimStore.claims.filter(x => x.claimNumber === claimNumber)[0];
      this.showExpenseAddView = true;
    });

    this.$on("close-add-expense", () => {
      this.claimStore.refreshLinkedExpenses(this.currentClaim.claimNumber);
      this.showExpenseAddView = false;
    });
  }

  addExpenseAction (event: any) {
    event.preventDefault();
    this.showExpenseAddView = !this.showExpenseAddView;
  }

  @Watch("$props", { deep: true })
  loadPage () {
    this.claimStore.loadClaims({
      pageNumber: this.claimStore.currentPage,
    }).catch(() => null); // the store rethrows the error
  }

  get isTufts (): boolean {
    return this.portalStore.partnerId === 6 || this.portalStore.partnerId === 13;
  }

  get isHPHC (): boolean {
    return this.portalStore.partnerId === 11;
  }

  onSwitchPage (pageNumber): void {
    this.claimStore.setPageNumber(pageNumber);
    this.claimStore.loadClaims({ pageNumber });
  }

  toSettings () {
    this.$router.push(this.SettingsRoute);
  }

}
